






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {store} from "@/_store";
import {SNACK_ACTION} from "@/_store/snackbar";
import {IMediaViewModel} from "@/_objects/IMedia";
import Confirm from "@/components/Confirm.vue";
import {updateApproveWithComments} from "@/_services/media.services";

@Component({
    components: {},
})
export default class MediaPreview extends Vue {
    @Prop() private url!: string;
    @Prop() private mediaType!: string;
    @Prop({default: false}) private show!: string;
    private text = "";
    private close() {
        this.$emit('update:show', false);
    }

    get officeUrl() {
        return "https://docs.google.com/viewer?url=" + this.url + "&embedded=true";
    }
}
